import Splide from '@splidejs/splide'

export const Dashboard = () => {
  new Splide('.splide-dashboard', {
    autoplay: true,
    type   : 'loop',
    perPage: 1,
  }).mount()
}

export const Home = () => {
  new Splide('.splide-home', {
    autoplay: true,
    type   : 'loop',
    perPage: 1,
  }).mount()
}

export const Testimonials = () => {
  new Splide('.splide-testimonials', {
    autoplay: true,
    type   : 'loop',
    perPage: 1,
  }).mount()
}

export const Tutorial = () => {
  new Splide('.splide-tutorial', {
    autoplay: true,
    type   : 'loop',
    perPage: 1,
    // gap: 20,
    arrows: false,
  }).mount()
}

export const Modal = () => {
  new Splide('.splide-modal', {
    autoplay: true,
    type   : 'loop',
    perPage: 1,
    // gap: 20,
    arrows: false,
  }).mount()
}
